import { Grid } from "@mui/material";
import React from "react";
import { useLocationInventoriesQuery } from "../../../hooks";
import {
  useBookingDate,
  useBookingNavigation,
  useFloors,
  useLocations,
  useSelectedInventories,
} from "../state";
import { BookingDatePicker } from "./BookingDatePicker";
import { DeskInventorySelector } from "./DeskInventorySelector";
import { FloorSelector } from "./FloorSelector";
import { LocationPicker } from "./LocationPicker";

export const DesktopBookingFiltersGrid: React.FC = () => {
  const { location, locations } = useLocations();
  const { floor, floors } = useFloors();
  const inventoriesQuery = useLocationInventoriesQuery(
    location!.id,
    floor ? floor.id : undefined
  );
  const { date } = useBookingDate();
  const { onChangeLocation, onChangeFloor, onChangeDate, onToggleInventory } =
    useBookingNavigation();

  const { selectedIds: selectedInventoryIds } = useSelectedInventories();

  if (!location) {
    throw new Error("Location must be loaded");
  }

  return (
    <Grid container spacing={{ xxs: 1, xs: 2, md: 2 }} justifyContent="center">
      <Grid item xxs={12} xs={6} md={3} xl={1.5}>
        <LocationPicker
          location={location}
          locations={locations}
          onChange={onChangeLocation}
        />
      </Grid>

      <Grid item xxs={6} xs={6} md={2} xl={1.5}>
        <FloorSelector
          floors={floors}
          floor={floor}
          onChangeFloor={onChangeFloor}
        />
      </Grid>

      <Grid item xxs={6} xs={6} md={2} xl={1.5}>
        <DeskInventorySelector
          assets={inventoriesQuery.data ?? []}
          selectedIds={selectedInventoryIds}
          onToggle={onToggleInventory}
        />
      </Grid>

      <Grid item xxs={12} xs={6} md={4} xl={2}>
        <BookingDatePicker date={date} onChange={onChangeDate} />
      </Grid>
    </Grid>
  );
};
